import { RegisterInfo } from "./inquiryRegister.model";

export interface Identity extends RegisterInfo{
    id_card: string;
    phone_number: string;
    update_chanel_identity_flag: boolean;  
}

export interface VerifyIdentity extends Identity {
    electronic_channel: number
}

export interface Customer {
    firstname: string,
    lastname: string,
    new_plateform_customer_flag?: number
}

export interface IdentityCustomerProfile extends Identity, Customer {
}

export enum ResponseCodeVerifyCustomer {
    SUCCESS = 'CM0001',
    NOTFOUND_IDCARD = 'F00000',
    NOTFOUND_PHONE = "CM0002",
    PHONE_NOT_MATCH = "L20001"
}
